import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import PpvInfo from '../../../pages/PpvInfo';
import SinglePpvWithYearsMobile from '../../MobileComponents/Ppv/SinglePpvWithYearsMobile';

const SinglePpvListYearResponsive = () => {
    const { isMobile } = useResponsiveRedux(); 
    return isMobile ? <SinglePpvWithYearsMobile /> : <PpvInfo />;
};

export default SinglePpvListYearResponsive;